export default __webpack_public_path__ + "static/image_about_s@2x-839a69d8ae7c2ba00cf4bf1c325d13a3.jpg";